
<template>
    <div class="entrance-page">
        <section class="top-part">
            <h1 class="page-title">
                <img v-if="lang == 'cn'" 
                    src="../img/hall-cover/top-title-cn.webp"
                />
                <img v-else
                    src="../img/hall-cover/top-title-en.webp"
                />
            </h1>
            <!-- 
                ↑ 上方标题
                ↓ 大厅列表 
            -->
            <div class="main-box">
                <div class="cell"
                    v-for="(oHall, idx) of aHalls"
                    :key="idx"
                >
                    <HallCover
                        :class="{ }"
                        :hallOrderNo="oHall.intOrder"
                        @click="fnGoIntoOneHall(oHall)"
                        :info="oHall"
                        :disabled="!oHall.accessable"
                    />
                </div>
            </div>
            
        </section>
         <!-- 
            ↑ 大厅列表 
            ↓ 下方按钮 
        -->
        <footer class="footer-bar">
            <ButtonThe3DButton
                class=""
                @click="goIntoRandomly()"
                size="lg"
                color="red"
            >
                {{ $t('redPacketMines.quickJoin') }}
            </ButtonThe3DButton>
        </footer>
       </div>
</template>


<script lang="ts">
import HallCover from '../_components/hallCover.vue';
import ButtonThe3DButton from '@/components/Button/The3DButton.vue';
import { toCloseLoading } from '@/layouts/gameCoat/ts/gameCoat'; 
import { fnGoIntoOneHall }  from '~/pages/casino/jisuzhajinhuaGame/ts/goldenFlowerCommon';
import { useGameSocket } from '@/socket/game';

export default defineComponent({ 
    name: 'goldenflowerGameEntrance',
    components: {
        HallCover,
        ButtonThe3DButton,
    },
    data(){
        return {
            // Static hall data instead of API calls
            staticHalls: [
                {
                    intOrder: 1,
                    name: 'trial',
                    displayName: '体验厅',
                    tableNum: 1,
                    minimumEntry: 0.1,
                    minBet: 0.1,
                    maxBet: 10,
                    accessable: true,
                    enabled: true,
                },
                {
                    intOrder: 2,
                    name: 'premium',
                    displayName: '娱乐厅',
                    tableNum: 2,
                    minimumEntry: 1,
                    minBet: 1,
                    maxBet: 100,
                    accessable: true,
                    enabled: true,
                },
                {
                    intOrder: 3,
                    name: 'rick',
                    displayName: '旗舰厅',
                    tableNum: 3,
                    minimumEntry: 10,
                    minBet: 10,
                    maxBet: 1000,
                    accessable: true,
                    enabled: true,
                },
                {
                    intOrder: 4,
                    name: 'vip',
                    displayName: '富豪厅',
                    tableNum: 4,
                    minimumEntry: 100,
                    minBet: 100,
                    maxBet: 10000,
                    accessable: true,
                    enabled: true,
                },
            ],
        };
    },
    computed:{
        aHalls(){
            if (import.meta.server) return []; 
            // Use static data instead of API call
            const aList01 = this.staticHalls;
            // 2x2布局：第一排体验厅(1)，娱乐厅(2)，第二排旗舰厅(3)，富豪厅(4)
            const aOrder = [1, 2, 3, 4];
            const aResult = aOrder.map(iNumber => {
                const oTarget = aList01.find((oThis, idx) => {
                    return oThis.intOrder == iNumber; 
                });
                return oTarget;
            }).filter(Boolean);
            return aResult; 
        },
        lang(){
            const $i18n = useNuxtApp().$i18n;
            return $i18n.locale.value;
        },
    },
    created(){
        
    },
    mounted(){
        toCloseLoading();
        // ↓ 进入大厅时调用 join 接口，参数传空
        // ↓ 这样当用户进入急速炸金花游戏大厅时，会调用 games.jisuzhajinhua.join 接口通知服务器，服务器会将该用户标记为"在游戏中"。
        // ↓ 如果同一账号在其他窗口打开同一游戏，服务器就会向旧窗口发送 log_off code 8888 事件。
        // ↓ 暂时先不加，等游戏房间加完join、exit再添加EMIT_GAME_JOIN、EMIT_GAME_EXIT
        // const { EMIT_GAME_JOIN } = useGameSocket();
        // EMIT_GAME_JOIN('jisuzhajinhua', {}, (res) => {
        //     console.log('jisuzhajinhua entrance join:', res);
        // });
    },
    beforeUnmount(){
        // const { EMIT_GAME_EXIT } = useGameSocket();
        // EMIT_GAME_EXIT('jisuzhajinhua');
    },
    methods:{
        fnGoIntoOneHall,
        goIntoRandomly(){
            // 按余额找出有权限的厅，然后随机进入 
            const oHall = this.aHalls.filter((cur, idx)=>{
                return cur.accessable;
            }).find((cur, idx, arr)=>{
                // console.log('arr', arr); 
                const bResult = (
                    (Math.random() > 0.5)
                    || (idx === arr.length - 1)
                );
                return bResult;
            });
            if (!oHall) {
                return; 
            }
            this.fnGoIntoOneHall(oHall);
        },
    },
});

</script>


<style scoped lang="scss" >
.entrance-page{
    max-width: 500px;
    margin: 0 auto; 
    height: calc(100vh - var(--header-heigh));
    max-height: calc(100vh - var(--header-heigh)); 
    position: relative;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    background-image: url(../img/bg-entrance.webp);
    background-size: cover;
    background-position: center; 
    overflow-y: auto; 
    --padding-x: 20px;
}
    
.top-part{
    padding: 8px var(--padding-x) 25px; 
    margin: 0 auto; 
    .page-title{
        opacity: 1; 
    }
}

.main-box{
    width: 100%; 
    margin: 0 auto; 
    padding: 3px 0 0; 
    display: grid;    
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
    row-gap: 15px;
    column-gap: 10px;
    .cell{
        display: flex;
        justify-content: center;
        align-items: center;
        .hall-cover{
            display: flex; 
            height: 100%; 
            width: 100%;
            max-width: 200px;
        }
    }
}


@media screen and (max-width: 400px){
    // .main-box{
    //     row-gap: 15px;
    //     column-gap: 30px;
    // }
    // .cell{
    //     .hall-cover{
    //         width: 120px;
    //     }
    // }
}

@media screen and (max-width: 360px){
    // .main-box{
    //     row-gap: 10px;
    //     column-gap: 25px;
    // }
    // .cell{
    //     .hall-cover{
    //         width: 110px;
    //     }
    // }
}

.footer-bar{
    flex: 0 0 auto; 
    width: 100%; 
    .button-3d{
        display: block; 
        margin: 0 auto; 
        width: calc(100% - 50px); 
    }
}
</style>


